import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Hamburger from "../../assets/Header/hamburger.svg";
import logo from "../../assets/logo.svg";
import ProfilePhoto from "../../assets/profilePhoto.svg";
import Alert from "../../components/Alert";
import styles from "./style.module.css";

const Header = ({ title, icon, toggleSidebar }) => {
	const [logoutModalShowing, toggleLogoutModal] = useState(false);
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	const history = useHistory();
	let userInfo = localStorage.getItem("user_info");
	if (!userInfo) {
		history.push("/login");
	}

	try {
		userInfo = JSON.parse(userInfo);
	} catch (e) {
		console.log(e);
	}

	async function logout() {
		try {
			const userId = userInfo?.id;

			await axios.post(`/logout/${userId}`);

			const isTaxpayer = /individual|corporate/i.test(
				userInfo?.account_type
			);
			localStorage.removeItem("user_info");
			localStorage.removeItem("access_token");
			history.push("/login", {
				anscims: !isTaxpayer
			});
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	}

	return (
		<header className={styles.header}>
			{alert.showing && <Alert text={alert.message} type={alert.type} />}
			<button aria-label="hamburger menu" onClick={toggleSidebar}>
				<img src={Hamburger} alt="Hamburger menu" />
			</button>
			<p className={styles.title}>
				{icon && (
					<img
						src={icon}
						alt={`${title} icon`}
						style={{ marginRight: "8px" }}
					/>
				)}{" "}
				{title}
			</p>
			<nav className={styles.nav}>
				<div className={styles.profile__information}>
					<span className={styles.bold__text}>
						{userInfo.account_type === "corporate"
							? userInfo.corpname
							: userInfo.fullname}
					</span>
					<span className={styles.regular__text}>
						{userInfo.email}
					</span>
				</div>
				<button
					className={styles.profile__toggle}
					onClick={() => toggleLogoutModal(!logoutModalShowing)}
				>
					<img
						src={
							userInfo.identityProofInfo?.biometricPhoto ||
							ProfilePhoto
						}
						alt="profile"
					/>
				</button>
				{logoutModalShowing && (
					<div className={styles.logout__modal}>
						<button
							style={{
								width: "100%",
								height: "100%",
								background: "none",
								border: "none"
							}}
							onClick={logout}
						>
							Logout
						</button>
					</div>
				)}
			</nav>
			<img src={logo} alt="EIRS logo" />
		</header>
	);
};

export default Header;
